import { InlineNotification } from '@carbon/react';

interface LandingPendingBannerProps {
  /** How many wells on the chart are still being re-landed. */
  count: number;
}

/**
 * The "re-landing" strip above the gun barrel (Story 1).
 *
 * A permit moved in depth is re-cut on the request, but its landing analysis runs
 * afterwards, and until it reports the chart draws the well at its new depth in the
 * colour of the formation it left, and the table names that formation. This says so,
 * for as long as the drawn slots carry a landing that has not reported. Same
 * notification the rotate's regeneration uses, so the two read as one kind of thing.
 *
 * @param {LandingPendingBannerProps} props - The held-well count.
 * @return {JSX.Element | null} The notification, or null when nothing is landing.
 */
export function LandingPendingBanner({ count }: LandingPendingBannerProps) {
  if (count <= 0) return null;
  const wells = count === 1 ? '1 well' : `${count} wells`;
  return (
    <InlineNotification
      kind="info"
      lowContrast
      hideCloseButton
      title={`Re-landing ${wells}…`}
      subtitle="Held wells are faded on the chart and read “Landing…” in the table. Their formation and position refresh when the landing analysis finishes."
      data-testid="landing-pending-banner"
    />
  );
}
